import { useState } from "react";

const CERRADA = { open: false, mensaje: "", severity: "", color: "" };

// Avisos del modal de pedido (Notify):
// - error: queda 6 s y al cerrarse sólo se oculta.
// - éxito: queda 1,5 s y al cerrarse se cierra el modal (onCerrarModal).
export const useNotificacion = ({ onCerrarModal }) => {
  const [notificacion, setNotificacion] = useState(CERRADA);

  const notificarError = (mensaje) => {
    setNotificacion({
      open: true,
      mensaje,
      severity: "error",
      color: "#FADBD8",
      duracion: 6000,
      cerrarModal: false,
    });
  };

  const notificarExito = (mensaje) => {
    setNotificacion({
      open: true,
      mensaje,
      severity: "success",
      color: "#D4EFDF",
      duracion: 1500,
      cerrarModal: true,
    });
  };

  const handleCloseNotificacion = () => {
    if (notificacion.cerrarModal) {
      onCerrarModal();
    } else {
      setNotificacion((prev) => ({ ...prev, open: false }));
    }
  };

  return { notificacion, notificarError, notificarExito, handleCloseNotificacion };
};
